export default __webpack_public_path__ + "static/media/logo.a54a7c56.ico";